interface BannerConfig {
  analyticsBannerId: string;
  href?: string;
  imageAlt: string;
  imageUrlDesktop: string;
  imageUrlMobile: string;
}

const DEFAULTS = {
  hrefForAgent: 'https://menora-rent.co.il/%D7%9E%D7%93%D7%9C%D7%9F/',
  hrefForPrivateUser: 'https://www.madlan.co.il/blog/%D7%94%D7%93%D7%A8%D7%9A-%D7%9C%D7%91%D7%99%D7%AA-%D7%A4%D7%95%D7%93%D7%A7%D7%90%D7%A1%D7%98-%D7%97%D7%93%D7%A9-%D7%9E%D7%91%D7%99%D7%AA-%D7%9E%D7%93%D7%9C%D7%9F/',
  imageAlt: 'Menora Insurance banner',
  promote: 'private user promote',
  conference: 'podcast for private users',
};

const uploadBulletinPopupBannersForPrivateUser: BannerConfig[] = [
  {
    analyticsBannerId: 'promote_private',
    href: undefined,
    imageAlt: DEFAULTS.promote,
    imageUrlDesktop: 'https://images2.madlan.co.il/email-templates/private_user_promote_desktop.png',
    imageUrlMobile: 'https://images2.madlan.co.il/email-templates/private_user_promote_mobile.jpg',
  },
];

const uploadBulletinPopupBannersForAgent: BannerConfig[] = [
  {
    analyticsBannerId: 'menora_set3_clear_head_v2',
    href: DEFAULTS.hrefForAgent,
    imageAlt: DEFAULTS.imageAlt,
    imageUrlDesktop: 'https://images2.madlan.co.il/email-templates/menora_set3_336x340_v2.png',
    imageUrlMobile: 'https://images2.madlan.co.il/email-templates/menora_set3_336x100_v2.png',
  },
  {
    analyticsBannerId: 'menora_set4_dont_wait_v2',
    href: DEFAULTS.hrefForAgent,
    imageAlt: DEFAULTS.imageAlt,
    imageUrlDesktop: 'https://images2.madlan.co.il/email-templates/menora_set4_336x340_v2.png',
    imageUrlMobile: 'https://images2.madlan.co.il/email-templates/menora_set4_336x100_v2.png',
  },
];

const manageBulletinsPageBannersForPrivateUser: BannerConfig[] = [
  {
    analyticsBannerId: 'podcast_private_banner',
    href: DEFAULTS.hrefForPrivateUser,
    imageAlt: DEFAULTS.conference,
    imageUrlDesktop: 'https://images2.madlan.co.il/email-templates/podcast_private_banner_730_90.png',
    imageUrlMobile: 'https://images2.madlan.co.il/email-templates/podcast_private_banner_336_100.png',
  },
];

const manageBulletinsPageBannersForAgent: BannerConfig[] = [];

const menoreBannersConfigs = {
  uploadBulletinPopup: {
    privateUser: uploadBulletinPopupBannersForPrivateUser,
    agent: uploadBulletinPopupBannersForAgent,
  },
  manageBulletinsPage: {
    privateUser: manageBulletinsPageBannersForPrivateUser,
    agent: manageBulletinsPageBannersForAgent,
  },
};

export function getBanner(key: keyof typeof menoreBannersConfigs, targetRole: 'agent' | 'privateUser'): BannerConfig | null {
  const bannersByTargetRole = menoreBannersConfigs[key];
  if (!bannersByTargetRole) return null;

  const banners = bannersByTargetRole[targetRole];
  if (!banners || banners.length === 0) return null;

  const randomIndex = Math.floor(Math.random() * banners.length);
  const bannerConfig = banners[randomIndex];

  return bannerConfig;
}
